require('./../../bootstrap');
import Vue from 'vue';
const moment = require('moment');
require('moment/locale/da');

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

Bugsnag.start({
    apiKey: '9b967fea46d1cdd5994877adb0c7a1eb',
    plugins: [new BugsnagPluginVue()],
    releaseStage: process.env.NODE_ENV === 'production' ? 'production' : 'local',
    enabledReleaseStages: ['production']
})

const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue)

import VueRouter from 'vue-router';
import {routes} from './routes';
import store from './store';
import VueClickOutside from 'v-click-outside';
import StripeAmountCalculator from './../../plugins/stripeAmountCalculator.js';
import VueAnimateNumber from 'vue-animate-number';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import VueDelay from 'vue-delay';
import VueClipboard from 'vue-clipboard2';
import Nl2br from 'vue-nl2br';
import AsyncComputed from 'vue-async-computed';

Vue.use(VueRouter);
Vue.use(VueClickOutside);
Vue.use(StripeAmountCalculator);
Vue.use(VueAnimateNumber);
Vue.use(VueDelay);
Vue.use(VueClipboard);
Vue.use(AsyncComputed);


const datepickerOptions = {
    sundayFirst: false,
    monthNames:[
        'Januar',
        'Februar',
        'Marts',
        'April',
        'Maj',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'December',
    ],
    days: ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'],
    daysShort: ['Man', 'Tir', 'Ons', 'Tors', 'Fre', 'Lør', 'Søn'],
    colors:{
        selected: '#B98C61',
    }
};
Vue.use(AirbnbStyleDatepicker, datepickerOptions);
Vue.use(require('vue-moment'), {
    moment
});

import Logout from './partials/logout.vue';
import Dashboard from './dashboard.vue';
import Dropdown from './../../general/dropdown.vue';
import PasswordField from './../../general/password';
import Modal from './../../general/modal.vue';
import Select from './../../general/select.vue';
import draggable from 'vuedraggable';
import Popup from "../../general/popup";

Vue.component('draggable', draggable);
Vue.component('ws-dropdown', Dropdown);
Vue.component('ws-password', PasswordField);
Vue.component('ws-modal', Modal);
Vue.component('ws-select', Select);
Vue.component('ws-popup', Popup);
Vue.component('nl2br', Nl2br);

const router = new VueRouter({
    routes,
    scrollBehavior (to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 })
            }, 350)
        })
    }
});

const app = new Vue({
    el: '#app',
    router,
    store,
    components:{
        app:Dashboard
    },
});



